"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LaptopOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M29.77 21.37A1 1 0 0029 21h-1V8a3 3 0 00-3-3H7a3 3 0 00-3 3v13H3a1 1 0 00-.77.37 1 1 0 00-.23.83l.38 1.8a5 5 0 004.9 4h17.44a5 5 0 004.9-4l.38-1.8a1 1 0 00-.23-.83zM6 8a1 1 0 011-1h18a1 1 0 011 1v13H6zm21.66 15.59A3 3 0 0124.72 26H7.28a3 3 0 01-2.94-2.41L4.22 23h8.16l.22.44A2.81 2.81 0 0015.13 25h1.74a2.81 2.81 0 002.53-1.56l.22-.44h8.16z"/><path d="M18 9a1 1 0 01-1 1h-2a1 1 0 010-2h2a1 1 0 011 1z"/>';
var LaptopOutlineSVG = function LaptopOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.LaptopOutlineSVG = LaptopOutlineSVG;
LaptopOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(LaptopOutlineSVG);
exports.default = _default;